import { Injectable } from '@angular/core';
declare const Swal;
@Injectable()


export class SweetAlert {
  constructor() {

  }
  swalFunction(Icon: any, Title: any, Text: any, Timer: any, TextOption: any = 'Titlecase') {

    let msg = Text;
    // if (TextOption == 'Titlecase') {
    //   msg = this.titleCase(Text)
    // }
    
    // if(typeof(Text)){}
    const ttl = this.titleCase(Title);

    Swal.fire({
      icon: Icon.toLowerCase(),
      title: ttl,
      //text: Text,
      text: msg,
      timer: Timer,
    });
    return;
  }

  // 1st letter cabitalized------------------------
  titleCase(msg) {
    let str;
    if (Array.isArray(msg)) str = msg[0];
    else str = msg;
    const splitStr = str.split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    // console.log('split string', splitStr.join(' '));
    return splitStr.join(' ');
  }
  // --------------------------------------


  swalDeleteFunction() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
    //   return
  }
}
